import { Component, OnInit, EventEmitter, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import {DateAdapter} from '@angular/material/core';
import {TranslateService} from 'ng2-translate/ng2-translate';
import { GeneralService } from '../../services/general.service';
import { ProvidersService } from '../../services/providers.service';
import * as decode from 'jwt-decode';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as XLSX from 'xlsx';

const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

@Component({
  selector: 'app-manual-payments',
  templateUrl: './manual-payments.component.html',
  styleUrls: ['./manual-payments.component.scss']
})
export class ManualPaymentsComponent implements OnInit {
  type: any;
  info: any = {};
  dataXml: any;
  loadBtn = false;
  userToken: any;
  userId: any;
  foreign = false;
  dataForeign: any = {};
  private base64textString: String = '';
  base64Pdf: string;
  filesArr = [];
  filesExcel = [];
  filesCountUpload = 0;
  showDrop = true;
  showDropExcel=true;
  step = 0;
  msgResp: any;
  uploadError = false;
  multipleCC = false;
  sendInfo: any = {};
  listSocieties = [];
  dataOriginalConcepts = [];
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  providersList = [];
  arrayBuffer:any;
  dataExcel = [];
  val:any;
  displayedColumns: string[] ;
  dataSource: any[] = [];
  uploader: FileUploader = new FileUploader({
    url: URL,
    isHTML5: true
  });
  msgBody = "Se cargo correctamente el gasto manual";
  msgTitle = "Cargar factura manual";
  header = [
    'Cuenta Mayor',
    'Centro de costos',
    'Texto de posición',
    'Importe',
    'Ind IVA'

  ];

  costosInput:any=[];

  hasBaseDropZoneOver = false;

  constructor(public dialog: MatDialog, private toastr: ToastrService, private gralService: GeneralService, private provService: ProvidersService, public translate: TranslateService, private adapter: DateAdapter<any>) {
    gralService.changeTextHead('SEARCHPAYMENTMANUAL');

    translate.onLangChange.subscribe(lang => {
      if(lang.lang == 'en'){
        this.adapter.setLocale('en-GB');
        this.msgBody = "Correct manual invoice loading";
        this.msgTitle = "Upload manual invoice";
      }

      if(lang.lang == 'es'){
        this.adapter.setLocale('es-MX');
        this.msgBody = "Se cargo correctamente el gasto manual";
        this.msgTitle = "Cargar factura manual";
      }
    });

    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;

    this.getSocieties();
  }

  ngOnInit() {
    this.loadProviders();
    this.initFilter();
  }

  initFilter() {
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
      startWith(''),
      map(value => this._filter(value))
      );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    //console.log('filterValue: ', filterValue);
    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders() {
    this.provService.getProvidersNum(this.userToken, this.sendInfo.Sociedad).then((res: any) => {
      this.initFilter();
      this.providersList = res.Entidades;
    });
  }

  addProveedorSearch(option) {
    //console.log('option', option);
    let proveedor = option.split(' - ');
    this.sendInfo.NumProveedor = proveedor[0];
    this.myControl.setValue(proveedor[0]);
  }
  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.sendInfo.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety();
        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety() {
    const society = this.listSocieties.find(x => x.NoSociedad == this.sendInfo.Sociedad);
    if (society.NumProveedor) {
      this.sendInfo.NumProveedor = society.NumProveedor;
    }
  }

  disabledProv() {
    let resp = false;
    if (this.sendInfo.Sociedad) {
      const society = this.listSocieties.find(x => x.NoSociedad == this.sendInfo.Sociedad);
      if (society.NumProveedor) {
        resp = true;
      }
    }
    return resp;
  }


  upp(evt){
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    this.fileUpload(file);
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  dropped(e){
    for(let g = 0; g < e.length; g++){
      this.fileUpload(e[g]);
    }
  }

  fileUpload(file){
    const exist = this.filesArr.find(x => x.name == file.name);
    if(exist){
      this.toastr.error('El archivo ' + file.name + ' ya esta en la lista.', 'Error al cargar archivo');
      this.loadBtn = false;
      return false;
    }

    const pattern = /image-*/;
    const patternPdf = /pdf/;
    const patternXml = /xml/;

    if(this.filesCountUpload < 2){
      if (!file.type.match(patternPdf)) {
        if (!file.type.match(patternXml)) {
          this.loadBtn = false;
          this.toastr.error('El archivo ' + file.name + ' tiene formato de archivo inválido, solo se acepta pdf y xml', 'Error al crargar archivo');
          return false;
        }else{
          this.filesArr.push({file: file, name: file.name, size: file.size, color: 'green', type: 'xml', date: '11-07-2018', error: null, id: 13, url: null});
        }
      }else{
        this.filesArr.push({file: file, name: file.name, size: file.size, color: 'green', type: 'pdf', date: null, error: null, id: null, url: 'http://concent.com.mx'});
      }

      this.filesCountUpload++;
      if(this.filesCountUpload >= 2){
        this.showDrop = false;
      }
    }
  }

  _loadxml(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.info.xmlBase64 = btoa(binaryString);
  }


  _loadPdf(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64Pdf = btoa(binaryString);
    this.info.pdfBase64 = btoa(binaryString);
  }

  deleteFile(idx){
    this.filesArr.splice(idx, 1);
    this.filesCountUpload--;
    if(this.filesCountUpload < 2){
      this.showDrop = true;
    }
  }

  upload(){
    if(this.filesArr.length == 0){
      this.loadBtn = false;
      this.toastr.error('Favor de agregar la factura', 'Error al crargar archivo');
      return false;
    }

    this.loadBtn = true;
    let existXml = false;
    let existPdf = false;

    for(let g = 0; g < this.filesArr.length; g++){
      if(this.filesArr[g].type == 'xml'){
        const reader = new FileReader();
        reader.onload = this._loadxml.bind(this);
        reader.readAsBinaryString(this.filesArr[g].file);
        existXml = true;
      }

      if(this.filesArr[g].type == 'pdf'){
        const reader = new FileReader();
        reader.onload = this._loadPdf.bind(this);
        reader.readAsBinaryString(this.filesArr[g].file);
        existPdf = true;
      }
    }

    setTimeout(() => {

      if (!existXml) {
        this.loadBtn = false;
        this.toastr.error('Favor de agregar el archivo XML', 'Cargar factura manual');
        return false;
      }

      if (!existPdf) {
        this.loadBtn = false;
        this.toastr.error('Favor de agregar el archivo PDF', 'Cargar factura manual');
        return false;
      }

      if (!this.sendInfo.Sociedad) {
        this.loadBtn = false;
        this.toastr.error('Favor de seleccionar la sociedad', 'Cargar factura manual');
        return false;
      }

    
      this.provService.uploadCreditNote({
        xmlB64: this.info.xmlBase64,
        Sociedad: this.sendInfo.Sociedad,
        NoProveedor: this.sendInfo.NumProveedor
      }, this.userToken).then((data) => {
        this.loadBtn = false;
        if(data['operacion']){
          //this.toastr.success('Archivo correcto', 'Cargar factura manual');
          this.dataXml = data['informacionXml'];
          let fechaXML = this.dataXml['fechaCFDI'];
          let currentYear = new Date().getFullYear();
          let CFDIAnio = fechaXML.split("-");
          if(CFDIAnio[0] < currentYear){
            this.loadBtn = false;
            this.toastr.error('Solo se permiten facturas del año en curso, fecha emision '+fechaXML, 'Cargar archivo');
            return false;
          }
          this.step = 1;
          this.getConcepts(this.dataXml.informacionConceptos);
            
        }else{
          this.loadBtn = false;
          this.toastr.error(data['mensaje'], 'Cargar archivo');
          return;
        }
      }, (err) => {
        console.log(err);
        this.loadBtn = false;
        this.toastr.error('Error al cargar archivo', 'Cargar factura manual');
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }
      });

    }, 1000);
  }
  
  reset(){
    this.step = 0;
    this.filesArr = [];
    this.filesCountUpload = 0;
    this.showDrop = true;
    this.loadBtn = false;

    this.sendInfo = {};
  }

  

  send() {
    this.loadBtn = true;

    if (!this.sendInfo.Sociedad || !this.sendInfo.NumProveedor) {
      this.loadBtn = false;
      this.toastr.error('Favor de agregar los datos obligatorios 1', 'Cargar factura manual');
      return false;
    }

    if (! this.multipleCC && !this.sendInfo.CuentaDeMayor ) {
      this.loadBtn = false;
      this.toastr.error('Favor de agregar los datos obligatorios 2', 'Cargar factura manual');
      return false;
    }

    var listaCCFinal = [];
    if (this.multipleCC) {

      var index = -1;
      var listaConcepto = [];
      var listaCC = [];

      let principal = null;
      //if (!this.sendInfo.CuentaDeMayor)
      //{
      //}
      let sumaConceptos = 0;
      let max = this.dataSource.length;
      this.dataSource.forEach(function (concepto,i) {
        console.log(" concepto "+JSON.stringify(concepto));
        if(concepto['cuentaMayor']){
          if (concepto['cuentaMayor']) {
            
            sumaConceptos += parseFloat(concepto['Importe'].replace(/,/g, ''));
            listaConcepto.push({
              //Descripcion: concepto['Descripcion'],
              //ClaveProdServ: concepto['Clave producto'],
              CuentaContable: concepto['cuentaMayor'],
              CentroCostos: concepto['centroCosto'],
              Importe: concepto['Importe'],
              TextoPosicion: concepto['textoPosicion'],
              ImpuestoTasa: concepto['Indiva']
            });
          }
          if (concepto['cuentaMayor']) {
            principal = concepto;
          }
        }
      });
      if (listaConcepto.length > 0) {
        //listaCC.push(listaConcepto);
        listaCC.push({
          Descripcion: principal.descripcion,
          ClaveProdServ: principal.claveProdServ,
          Importe: principal.importe,
          Conceptos: listaConcepto
        });
        listaConcepto = [];
      }
      console.log(" sma "+sumaConceptos);
      console.log("listaCC %o ", listaCC);
      var isValidImporte = true;
      var toastrCopy = this.toastr;
      isValidImporte = true;
      let totalXML = this.dataXml.subtotal;
      if(totalXML.toFixed(2) !== sumaConceptos.toFixed(2)){
        isValidImporte = false;
        toastrCopy.error('La suma de los importes del excel es diferentes al total, el total del XML es de '+totalXML.toFixed(2)+', mientas la suma de los importes del excel es '+sumaConceptos.toFixed(2), 'Cargar factura manual',
        { disableTimeOut: true });
      }

      /*listaCC.forEach(function (concepto) {
        //console.log("concepto %o ", concepto);

        var sumConcepto = concepto.Conceptos.reduce(function (acc, val) { return acc + val.Importe; }, 0);
        if (isNaN(sumConcepto)){
          console.log(" sum concepto ");
          sumConcepto = 0;
        }
        if (sumConcepto != concepto.Importe) {
          toastrCopy.error('Concepto: ' + concepto.ClaveProdServ + " - " + concepto.Descripcion + ", La suma de los SubImporte: " + sumConcepto + " no es igual al importe del Concepto original: " + concepto.Importe, 'Cargar factura manual',
            { disableTimeOut: true });
          //timeOut = false;
          isValidImporte = false;
        }
      });*/

      if (!isValidImporte)
        return false;

      listaCC.forEach(function (concepto,index) {
        listaCCFinal.push(concepto['Conceptos']);
      });
    }


    var toastrCopy = this.toastr;
    var isValidImpuesto = true;
    //validacion de impuetos seleccionados
    this.dataXml.informacionImpuestos.forEach(function (impuesto) {
      if (impuesto.idImpuestoSAPSeleccionado == 0 ) {
        toastrCopy.error('Impuesto: ' + impuesto.impuestoNombre + ", No se ha seleccionado un impuesto SAP para este impuesto.", 'Cargar factura manual',
          { disableTimeOut: true });
        isValidImpuesto = false;
      }
    });

    if (!isValidImpuesto) {
      return false;
    }

    this.sendInfo.Xml = this.info.xmlBase64;
    this.sendInfo.Pdf = this.info.pdfBase64;
    this.sendInfo.IdUsuario = this.userId
    this.sendInfo.CentrosCostosConceptos = listaCCFinal;
    this.sendInfo.informacionImpuestos = this.dataXml.informacionImpuestos;

    

    this.provService.addManualPayment(this.sendInfo, this.userToken).then((data) => {
      if(data['operacion']){
        this.toastr.success(this.msgBody, this.msgTitle);
        this.reset();
      }else{
        let msgs = '';
        for(let g = 0; g < data['listaMensajes'].length; g++){
          msgs = msgs+'<br>- '+data['listaMensajes'][g];
        }
        this.loadBtn = false;
        this.toastr.error(msgs, 'Cargar factura manual', { disableTimeOut: true });
        return;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
        this.toastr.error(JSON.stringify(err), 'Cargar factura manual', { disableTimeOut: true });
        return;
    });
  }

  addLineCC(rowIndex,row) {
    console.log(row);
    var target = this.iterationCopy(row);
    console.log(target);
    this.dataXml.informacionConceptos.splice(rowIndex + 1 , 0, target );
    console.log(this.dataXml.informacionConceptos);
  }

  removeLineCC(rowIndex) {
    this.dataXml.informacionConceptos.splice(rowIndex , 1 );
    console.log(this.dataXml.informacionConceptos);
  }

  iterationCopy(src) {
    var target = {};
    for (let prop in src) {
      if (src.hasOwnProperty(prop)) {
        target[prop] = src[prop];
      }
    }
    target['principal'] = false; 
    return target;
  }

  uploadMultipesCC() {

    if (this.multipleCC) {
      this.multipleCC = true;
      this.dataXml.informacionConceptos = JSON.parse(JSON.stringify(this.dataOriginalConcepts));
      console.log(" this.dataOriginalConcepts %o ", this.dataOriginalConcepts);
    } else {
      this.multipleCC = false;
      this.sendInfo.CuentaDeMayor = null;
      this.sendInfo.CentroCostos = null;
      this.sendInfo.TextoPosiciones = null;
    }
  }

  getConcepts(data) {

    let conceptosTemp = data;
    var idRow = 0;
    if (conceptosTemp.length > 0) {
      conceptosTemp.forEach(function (concepto) {
        concepto.index = idRow++;
        concepto.principal = true;
        concepto.CentroCostos = '';
        concepto.CuentaContable = '';
        concepto.TextoPosicion = '';
        //concepto.costosInput = [];
        //concepto.costosInput.push({ CentroCostos: '', CuentaContable: '' });
      });
    }

    this.dataOriginalConcepts = JSON.parse(JSON.stringify(conceptosTemp));
  }

  _loadExcel(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64Pdf = btoa(binaryString);
    this.info.excelBase64 = btoa(binaryString);
  }

  fileUploadExcel(file){
    const patternXls = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const patternXls2 = /xlsx/;

    if (!file.type.match(patternXls) ) {

      this.toastr.error('El archivo ' + file.name + ' tiene formato de archivo inválido, solo se acepta xls', 'Error al cargar archivo');
        return false;
    }

      this.filesExcel.push({file: file, name: file.name, size: file.size, color: 'green', type: 'xls', date: null, error: null, id: null, url: 'http://concent.com.mx'});
      this.showDropExcel = false;
      let fileReader = new FileReader();
        fileReader.onload = (e) => {
            this.arrayBuffer = fileReader.result;
            let data = new Uint8Array(this.arrayBuffer);
            let arr = new Array();
            for(let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
            let bstr = arr.join("");
            let workbook = XLSX.read(bstr, {type:"binary"});
            let first_sheet_name = workbook.SheetNames[0];
            let worksheet = workbook.Sheets[first_sheet_name];
            this.dataExcel = XLSX.utils.sheet_to_json(worksheet,{raw:true})
            console.log(this.dataExcel);
        }
        console.log(file);
        fileReader.readAsArrayBuffer(file);
        
  }

  uppExcel(evt){
    console.log("upp excel");
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    this.fileUploadExcel(file);
  }

  fileOverBaseExcel(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  droppedExcel(e){
    for(let g = 0; g < e.length; g++){
      this.fileUploadExcel(e[g]);
    }
  }

  deleteFileExcel(idx){
    this.filesExcel.splice(idx, 1);
    //this.filesCountUpload--;
    this.showDropExcel = true;
  }

  data(event:ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    pastedText = "cuentaMayor\tcentroCosto\ttextoPosicion\tImporte\tIndiva\n"+pastedText
    let row_data = pastedText.split('\n');
    this.displayedColumns = row_data[0].split('\t');
    delete row_data[0];
    // Create table dataSource
    let data=[];
    row_data.forEach(row_data=>{
        let row={};
      this.displayedColumns.forEach((a, index)=>{row[a]= row_data.split('\t')[index]});
      data.push(row);
    })
    this.dataSource = data;
    }

}


